import { ErrorBoundary } from "react-error-boundary";
import ErrorboundaryMessage from "./ErrorboundaryMessage";
export default function AppErrorBoundary({ children }) {
  return (
    <ErrorBoundary
      FallbackComponent={({ error }) => (
        <ErrorboundaryMessage err={error?.message || "Render error"} />
      )}
      onError={(error, info) => {
        console.error("Caught by ErrorBoundary:", error, info);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
